import { AfterViewInit, Component, effect, ElementRef, inject, ViewChild } from '@angular/core';

import { LoaderComponent, SafePipe } from 'mbs-ui-kit';

import { CommonModule } from '@angular/common';
import { ThemeService } from '@services/theme.service';
import { PageLayoutComponent } from 'mbs-ui-shared@components/page-layout/page-layout.component';

@Component({
  selector: 'mbs-marketing-iframe',
  templateUrl: './marketing-iframe.component.html',
  styles: [],
  imports: [CommonModule, LoaderComponent, SafePipe, PageLayoutComponent]
})
export class MarketingIframeComponent implements AfterViewInit {
  private themeService = inject(ThemeService);

  // Pass the current theme to the embedded page so it can match our light/dark mode.
  public readonly marketingSrc = `https://get.msp360.com/mspbackupsmarketingv2?theme=${this.themeService.isDark() ? 'dark' : 'light'}`;

  public showLoader = true;
  private iframeLoaded = false;

  @ViewChild('iframe', { static: true }) marketingIframe: ElementRef<HTMLIFrameElement>;

  constructor() {
    effect(() => {
      const theme = this.themeService.isDark() ? 'dark' : 'light';
      if (!this.iframeLoaded) return;
      this.marketingIframe.nativeElement?.contentWindow?.postMessage({ msg: 'mbs-theme', theme }, '*');
    });
  }

  ngAfterViewInit(): void {
    this.marketingIframe.nativeElement.onload = () => {
      this.showLoader = false;
      this.iframeLoaded = true;
    };
  }
}
